import type { AxiosPromise, AxiosRequestConfig } from 'axios';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { api } from '@/api';

export async function getHelpcenterArticle(
  params: openapi.ListArticlesQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.ListArticlesContentOpenapi> {
  return await api.get<openapi.ListArticlesContentOpenapi>(
    '/helpcenter/article/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getHelpcenterArticleById(
  params: openapi.GetArticleByIdQueryOpenapi,
  path: openapi.GetArticleByIdPathOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetArticleByIdContentOpenapi> {
  return await api.get<openapi.GetArticleByIdContentOpenapi>(
    `/helpcenter/article/${path.id}/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postHelpcenterArticleByIdUpvote(
  params: openapi.UpvoteArticleQueryOpenapi,
  path: openapi.UpvoteArticlePathOpenapi,
  data: openapi.UpvoteArticleBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.UpvoteArticleContentOpenapi> {
  return await api.post<openapi.UpvoteArticleContentOpenapi>(
    `/helpcenter/article/${path.id}/upvote/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postHelpcenterArticleByIdDownvote(
  params: openapi.DownvoteArticleQueryOpenapi,
  path: openapi.DownvoteArticlePathOpenapi,
  data: openapi.DownvoteArticleBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.DownvoteArticleContentOpenapi> {
  return await api.post<openapi.DownvoteArticleContentOpenapi>(
    `/helpcenter/article/${path.id}/downvote/`,
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getHelpcenterArticleRoute(
  params: openapi.GetArticlesByRouteQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetArticlesByRouteContentOpenapi> {
  return await api.get<openapi.GetArticlesByRouteContentOpenapi>(
    `/helpcenter/article/route/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getHelpcenterTopSearches(
  params: openapi.ListTopSearchesQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.ListTopSearchesContentOpenapi> {
  return await api.get<openapi.ListTopSearchesContentOpenapi>(
    '/helpcenter/top-searches/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getHelpcenterRecentUpdates(
  params: openapi.ListRecentUpdatesQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.ListRecentUpdatesContentOpenapi> {
  return await api.get<openapi.ListRecentUpdatesContentOpenapi>(
    '/helpcenter/recent-updates/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getHelpcenterFaq(
  params: openapi.ListFAQQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.ListFAQContentOpenapi> {
  return await api.get<openapi.ListFAQContentOpenapi>('/helpcenter/faq/', {
    ...requestConfig,
    params,
  });
}

export async function getHelpcenterArticleSearch(
  params: openapi.SearchArticlesQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.SearchArticlesContentOpenapi> {
  return await api.get<openapi.SearchArticlesContentOpenapi>(
    '/helpcenter/article/search/',
    {
      ...requestConfig,
      params,
    },
  );
}
